import * as React from "react";

import { nameToTitle } from "web_modules/capital_markets_dashboard/shared/utils";

const FontAwesome = require("react-fontawesome");

const styles = require("./styles.module.scss");

const EditsPresentAlert = ({ name }: { name: string }) => (
  <div className={styles.container}>
    <FontAwesome className={styles.icon} name="bar-chart" />
    <div className={styles.text}>
      <div className={styles.headline}>{nameToTitle(name)} pricing has been modified</div>
      <div className={styles.detail}>
        Click the save button to apply update, or click the cancel button to cancel all changes.
      </div>
    </div>
  </div>
);

export default EditsPresentAlert;
